"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultController__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DepositForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawnFailed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "EnumerableMapNonexistentKey",
        type: "error",
    },
    {
        inputs: [],
        name: "InitializedAlready",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidDepositTimeRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "InvalidStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
        ],
        name: "InvalidWithdrawableTime",
        type: "error",
    },
    {
        inputs: [],
        name: "MoveForbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "MovedAlready",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReward",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "NonexistentStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInDepositPeriod",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInWithdrawPeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyFactory",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "SafeERC20FailedOperation",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
            },
        ],
        name: "CoinAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "coins",
        outputs: [
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "coinsExists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "coinsLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "decimalsOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositEndTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositFill",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "emergencyWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hasMoved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "moveToTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardAsset",
        outputs: [
            {
                internalType: "contract IStableCoin",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositCap",
                type: "uint256",
            },
        ],
        name: "setDepositCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "withdrawableTime",
                type: "uint256",
            },
        ],
        name: "setTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawableBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class VaultController__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_factory, overrides) {
        return super.getDeployTransaction(_factory, overrides || {});
    }
    deploy(_factory, overrides) {
        return super.deploy(_factory, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.VaultController__factory = VaultController__factory;
